// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","lg":"styles_lg__2qigu","sm":"styles_sm__3wLv_"};